
import { useCallback, useEffect, useState } from "react";
import { PwaHelper } from "../../../utils/PwaHelper";

export default function PwaInstall() {
	const [deferredPrompt, setDeferredPrompt] = useState(null);
	const [shouldShow, setShouldShow] = useState(false);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		setShouldShow(PwaHelper.shouldShow());
	}, []);

	useEffect(() => {
		const handleBeforeInstallPrompt = (event) => {
			event.preventDefault();
			if (!shouldShow) {
				return;
			}
			setDeferredPrompt(event);
			setVisible(true);
		};

		window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

		return () => {
			window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
		};
	}, [shouldShow]);

	const handleInstall = useCallback(async () => {
		setVisible(false);
		PwaHelper.onShowPwaInstallMessage();
		if (!deferredPrompt) return;
		deferredPrompt.prompt();
		const result = await deferredPrompt.userChoice;
		if (result.outcome === "accepted") {
			setDeferredPrompt(null);
		}
	}, [deferredPrompt]);

	const handleDismiss = () => {
		setVisible(false);
		PwaHelper.onShowPwaInstallMessage();
	};

	if (!visible) {
		return null;
	}

	return (
		<div className="px-4 pb-3 pt-2">
			<div
				className="mx-auto max-w-[360px] overflow-hidden rounded-2xl border border-[#E8EEF5] bg-white shadow-[0_8px_32px_rgba(39,106,166,0.12)]"
				role="dialog"
				aria-labelledby="pwa-install-title"
			>
				<div className="h-1 bg-gradient-to-l from-cta via-darkBlue to-darkBlue" />
				<div className="p-4 text-center">
					<p
						id="pwa-install-title"
						className="font-Vazir-800 text-[16px] text-darkBlue leading-snug"
					>
						نصب اپلیکیشن همراهتیم
					</p>
					<p className="font-Vazir-400 text-[13px] text-midGray mt-2 leading-relaxed">
						نسخهٔ PWA را نصب کنید تا سریع‌تر و راحت‌تر به کارگاه‌ها و وبینارها دسترسی
						داشته باشید.
					</p>
					<div className="mt-4 flex flex-row-reverse gap-2">
						<button
							type="button"
							className="flex-1 rounded-xl bg-cta py-2.5 font-Vazir-700 text-[14px] text-white shadow-[0_4px_14px_rgba(255,106,75,0.35)] active:scale-[0.98] transition-transform"
							onClick={handleInstall}
						>
							نصب
						</button>
						<button
							type="button"
							className="rounded-xl border border-[#E2E8F0] bg-white px-4 py-2.5 font-Vazir-600 text-[14px] text-midGray hover:bg-lightCta/80 transition-colors"
							onClick={handleDismiss}
						>
							بعداً
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
